<template>
  <div>
    <v-col cols="12">
      <div class="plan-heading">Ebility Membership Plans</div>
      <div class="intro-text">
        <!-- Early bird pricing, only applicable for the <b> first 100 members! </b> -->
        Early bird pricing, only applicable for a limited time.
      </div>
    </v-col>
    <v-row
      class="ma-0"
      justify="center"
      v-if="$store.state.isMembershipEnabled"
    >
      <PlanDetailsCard
        v-if="trial"
        :plan="trial"
        :monthly="monthly"
        :isMostPopular="false"
        :isSelected="true"
        :isDisabled="!isFirstMembership"
        :showGreenTag="false"
        class="ma-2"
      />
      <PlanDetailsCard
        :plan="monthly"
        :monthly="null"
        :isMostPopular="true"
        :isSelected="false"
        :isDisabled="false"
        :showGreenTag="true"
        class="ma-2"
      />
    </v-row>
    <v-row class="ma-0" justify="center" v-else>
      <PlanDetailsCard
        :plan="communityPlan"
        :monthly="null"
        :isMostPopular="false"
        :isSelected="false"
        :showGreenTag="false"
        :isDisabled="isUserLoggedIn"
        class="ma-2"
      />
      <PlanDetailsCard
        :plan="premiumPlan"
        :monthly="null"
        :isMostPopular="true"
        :isSelected="true"
        :showGreenTag="true"
        :isDisabled="false"
        :isDirectEnrolment="$route.query.is_enrolment"
        class="ma-2"
      />
    </v-row>
    <!-- <v-row class="ma-0" justify="center">
      <PlanDetailsCard :plan="quaterly" :isMostPopular="false" class="ma-2" />
      <PlanDetailsCard :plan="annually" :isMostPopular="false" class="ma-2" />
    </v-row> -->
  </div>
</template>

<script>
  import { ROUTER_URL } from "../../constants/keys";
  import PlanDetailsCard from "./PlanDetailsCard";
  import authToken from "../../common/authToken";

  export default {
    name: "MembershipPlans",
    props: ["trial", "monthly", "quaterly", "annually", "premiumPlan"],
    components: {
      PlanDetailsCard,
    },
    data() {
      return {
        plans: null,
        isFirstMembership: authToken.decodedToken().membership_validity
          ? false
          : true,
        isMember: authToken.decodedToken().is_member,
      };
    },
    created() {
      this.$store.state.membership.freeMembership = this.trial;
    },
    computed: {
      isUserLoggedIn() {
        return this.$store.state.isLoggedIn;
      },
      isMembershipCheckoutEnable: {
        get() {
          return this.$store.state.membership.isMembershipCheckoutEnable;
        },
        set(value) {
          this.$store.dispatch(
            "membership/updateMembershipCheckoutEnable",
            value
          );
        },
      },
      membershipDetails: {
        get() {
          return this.$store.state.membership.selectedMembership;
        },
        set(value) {
          this.$store.dispatch("membership/updateSelectedMembership", value);
        },
      },
      communityPlan() {
        return {
          name: "Community Plan",
          display_price: "10",
          currency_details: {
            symbol: "$",
          },
          price: 0,
          is_signup: true,
        };
      },
    },
    watch: {
      isUserLoggedIn() {
        this.isFirstMembership = authToken.decodedToken().membership_validity
          ? false
          : true;
        this.isMember = authToken.decodedToken().is_member;
      },
    },
    methods: {
      subscribe(plan) {
        this.$store.state.payment.sessionSeriesId = null;
        this.$store.state.sessionSeriesDetails.data = null;
        this.$store.state.membership.isRenewMembership = false;
        this.membershipDetails = plan;
        this.$router.push({
          name: ROUTER_URL.publicSession.children.membershipCheckout.name,
        });
      },
    },
    mounted() {},
  };
</script>

<style scoped>
  .plan-heading {
    font-weight: 800;
    font-size: 32px;
    line-height: 44px;
    color: #506cff;
    text-align: center;
  }

  .intro-text {
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #444444;
    text-align: center;
  }
</style>
